import { useQuery } from '@mint-lib/query-client';
import { useService } from '@mint-lib/routing-context';
import { AppsFlyerIntegrations } from '@mint-sdk/api-integrations';

export const useGetAppsFlyerIntegrations = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  const [queryClient] = useService({
    name: 'queryClient',
    suspense: true,
  });

  const { data, isLoading } = useQuery(
    {
      ...AppsFlyerIntegrations.getQueryOptions({}),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled,
    },
    queryClient,
  );

  return {
    data,
    isLoading,
  };
};
